import { useMutation } from 'react-query'

import { APIError, APIResponse } from '../../../utils'
import { updateContact } from '../query-api'
import { Contact } from '../types/contact'

interface UseUpdateContactProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: APIResponse<Contact>) => void
}

export const useUpdateContact = (props?: UseUpdateContactProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: update,
    isLoading: isProcessing,
    ...rest
  } = useMutation(updateContact, {
    onSuccess,
    onError,
  })

  return { update, isProcessing, ...rest }
}
